// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';

// ANTD
import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import constants from 'lib/constants';

const styles = {
  planCard: {
    position: 'relative',
    height: 250,
    background: '#FFF',
    display: 'flex',
    margin: 5,
    marginTop: 15,
    marginBottom: 75,
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0 8px 18px 0 #C0DCE5, 0 4px 4px 0 #A4D5E6',
  },
  planTitle: {
    fontSize: 20,
    fontWeight: 500,
    color: '#41424a',
  },
  imageStyle: {
    height: 80,
    position: 'absolute',
    left: 'calc(50% - 40px)',
    right: 0,
    top: -35,
  },
  iconGroupStyle: {
    height: 40,
    position: 'absolute',
    left: 'calc(50% - 68px)',
    right: 0,
    top: 160,
  },
  imageStyleActive: {
    height: 80,
    position: 'absolute',
    left: 'calc(50% - 40px)',
    right: 0,
    top: -55,
  },
};

const PlanCardContainer = styled.div`
  position: relative;
  height: 250px;
  background: #fff;
  display: flex;
  margin: 5px;
  margin-top: 15px;
  margin-bottom: 75px;
  padding: 15px;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 8px 18px 0 #c0dce5, 0 4px 4px 0 #a4d5e6;
  @media only screen and (max-width: 400px) {
    margin: 15px;
    margin-bottom: 65px;
  }
`;

class ProductCard extends React.Component {
  state = {
    showDescription: false,
  };

  renderDescription = () => {
    const { plan } = this.props;
    return (
      <div>
        <img style={styles.imageStyleActive} src={plan.icon} />
        <div>{plan.description}</div>
      </div>
    );
  };

  renderNormalContent = () => {
    const { plan } = this.props;
    return (
      <div>
        <img style={styles.imageStyle} src={plan.icon} />
        <div style={styles.planTitle}>{plan.title}</div>
      </div>
    );
  };

  onMouseEnter = () => {
    this.setState({ showDescription: true });
  };

  onMouseLeave = () => {
    this.setState({ showDescription: false });
  };

  onClick = () => {
    const { plan } = this.props;
    this.props.history.push(`/dashboard-preview/${plan.productId}`);
  };

  render() {
    const { plan } = this.props;
    return (
      <PlanCardContainer
        role="textbox"
        tabIndex={0}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onClick}
      >
        <div>
          <img style={styles.imageStyle} src={plan.icon} alt="plan" />
          {this.state.showDescription ? (
            <div className="center">
              <p style={{ fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: plan.description }} />
              <div className="mt2" />
              <p style={{ color: '#e55a2f' }} className="bold">
                LEARN MORE
              </p>
            </div>
          ) : (
            <div style={styles.planTitle}>
              {plan.title}
              {plan.iconGroup && <img style={styles.iconGroupStyle} src={plan.iconGroup} alt="group icon" />}
            </div>
          )}
        </div>
      </PlanCardContainer>
    );
  }
}

const ProductList = ({ history }) => (
  <Row gutter={20} type="flex" align="middle" justify="center">
    {constants.plansList.map(plan => (
      <Col key={plan.productId} xs={24} sm={12} md={8}>
        <ProductCard plan={plan} history={history} />
      </Col>
    ))}
  </Row>
);

const BottomButton = () => (
  <div style={{ marginTop: 40, height: 100, textAlign: 'center' }}>
    <Button type="primary" className="round-button">
      VIEW PLANS
    </Button>
  </div>
);

const PlansSection = props => (
  <Row
    type="flex"
    align="middle"
    justify="center"
    id="plans"
    style={{
      minHeight: 700,
      background: '#EBEFF1',
      paddingTop: 88,
      paddingBottom: 10,
    }}
  >
    <div style={{ width: 1100, maxWidth: '100%' }}>
      <h1 style={{ textAlign: 'center', marginBottom: 88 }}>Products</h1>
      <ProductList {...props} />
    </div>
  </Row>
);

export default PlansSection;



// WEBPACK FOOTER //
// ./src/routes/app-home/PlansSection/index.js